import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './Modal.module.scss';

export type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  buttonClose?: boolean;
  title?: string;
  vw?: number;
  vh?: number;
  minWidth?: number;
  minHeight?: number;
  maxWidth?: number;
  maxHeight?: number;
  clickOutsideToClose: boolean;
  onScrollEnd?(): void;
  children: React.ReactNode;
};

function Modal({
  isOpen,
  onClose,
  buttonClose = true,
  title,
  children,
  clickOutsideToClose,
  vw,
  vh,
  minWidth,
  minHeight,
  maxWidth,
  maxHeight,
  onScrollEnd,
}: ModalProps) {
  const style: React.CSSProperties = {
    ...(vw ? { width: `${vw}vw` } : {}),
    ...(vh ? { height: `${vh}vh` } : {}),
    ...(minWidth ? { minWidth: `${minWidth}px` } : {}),
    ...(minHeight ? { minHeight: `${minHeight}px` } : {}),
    ...(maxWidth ? { maxWidth: `${maxWidth}px` } : {}),
    ...(maxHeight ? { maxHeight: `${maxHeight}px` } : {}),
  };

  function onScroll(event: React.UIEvent<HTMLDivElement>) {
    const container: Partial<HTMLDivElement> = event.target;

    if (
      container.scrollHeight! - container.scrollTop! ===
      container.clientHeight
    ) {
      onScrollEnd?.();
    }
  }

  return (
    <div
      data-testid="container"
      className={`${styles.container} ${isOpen ? styles.open : ''}`}
    >
      {isOpen && (
        <div className={`${styles.modal}`} role="dialog" style={style}>
          {buttonClose || title ? (
            <div
              className={`${styles.header} ${title ? styles.withTitle : ''} ${
                buttonClose ? styles.withButtonClose : ''
              }`}
            >
              {title && <h4 className={styles.title}>{title}</h4>}

              {buttonClose && (
                <button
                  type="button"
                  className={styles.buttonClose}
                  onClick={onClose}
                  data-testid="buttonClose"
                >
                  <FontAwesomeIcon icon="times" size="lg" color="#666" />
                </button>
              )}
            </div>
          ) : null}
          <div className={styles.content}>
            <div
              onScroll={onScroll}
              className={`${styles.children}`}
              data-testid="modal-children"
            >
              {children}
            </div>
          </div>
        </div>
      )}
      <div
        data-testid="background"
        className={styles.background}
        onMouseDown={clickOutsideToClose ? onClose : undefined}
        role="presentation"
      />
    </div>
  );
}

export default Modal;
